import { render, staticRenderFns } from "./ServicoForm.vue?vue&type=template&id=43f51058&"
import script from "./ServicoForm.vue?vue&type=script&lang=js&"
export * from "./ServicoForm.vue?vue&type=script&lang=js&"
import style0 from "./ServicoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports